import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import BackButton from './back-button';
import * as commonStyles from './common.style';
import * as styles from './land-contour-panel.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LandContourLegend = () => ___EmotionJSX("div", {
  css: styles.contourLegendContainer
}, ___EmotionJSX("div", {
  css: styles.contourLegend
}, ___EmotionJSX("span", {
  css: styles.tenMetreContour
}), ___EmotionJSX("span", {
  css: styles.contourLabel
}, "10 Metre")), ___EmotionJSX("div", {
  css: styles.contourLegend
}, ___EmotionJSX("span", {
  css: styles.twoMetreContour
}), ___EmotionJSX("span", {
  css: styles.contourLabel
}, "2 Metre")));
var LandContourPanel = _ref => {
  var title = _ref.title,
    description = _ref.description,
    onBack = _ref.onBack,
    media = _ref.media;
  return ___EmotionJSX("div", {
    css: commonStyles.container
  }, media.mobile && ___EmotionJSX("p", {
    css: commonStyles.title
  }, title), (media.tablet || media.mobile) && ___EmotionJSX(LandContourLegend, null), (media.tablet || media.desktop) && ___EmotionJSX("p", {
    css: commonStyles.title
  }, title), ___EmotionJSX("div", {
    css: commonStyles.description,
    dangerouslySetInnerHTML: {
      __html: description
    } // eslint-disable-line react/no-danger
  }), media.desktop && ___EmotionJSX(LandContourLegend, null), ___EmotionJSX(BackButton, {
    onClick: onBack
  }));
};
LandContourPanel.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onBack: PropTypes.func.isRequired,
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    desktop: PropTypes.bool
  }).isRequired
};
LandContourPanel.defaultProps = {
  title: 'Land contours',
  description: 'This represents the shape of the geographical land. Closely spaced contour lines represent a steep slope. Widely spaced lines represent a gentle slope. Contours are based on 2015 data and should not be used for design work.'
};
export default withMedia(LandContourPanel);